import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  Typography,
  Box,
} from "@mui/material";
import dayjs from "dayjs";

const LogsTable = ({ logs }) => {
  const getColor = (level) => {
    if (level === "error") return "error";
    if (level === "warn") return "warning";
    return "success";
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "-";
    return dayjs(timestamp).format("MMM DD, YYYY HH:mm:ss");
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Timestamp (NST)</TableCell>
          <TableCell>Level</TableCell>
          <TableCell>Category</TableCell>
          <TableCell>Action</TableCell>
          <TableCell>Message</TableCell>
          <TableCell>User</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {logs.map((log) => {
          return (
            <TableRow key={log._id}>
              <TableCell>
                {formatTimestamp(log.metadata?.localTimestamp || log.timestamp)}
              </TableCell>

              <TableCell>
                <Chip
                  label={log.level}
                  color={getColor(log.level)}
                  size="small"
                />
              </TableCell>

              <TableCell>{log.metadata?.category || "-"}</TableCell>
              <TableCell>{log.metadata?.action || "-"}</TableCell>

              <TableCell>{log.message}</TableCell>

              <TableCell>
                {log.metadata?.userEmail ? (
                  <Box>
                    <Typography fontWeight="bold">
                      {log.metadata.userName || "-"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {log.metadata.userEmail}
                    </Typography>
                  </Box>
                ) : (
                  "-"
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default LogsTable;
